var React = require('react');

function LocationIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 7.60537C0 3.41177 3.36448 0 7.5 0C11.6355 0 14.9999 3.41177 15 7.60537C15 12.8098 8.28823 20.4501 8.00248 20.7728C7.73455 21.0755 7.26593 21.076 6.99752 20.7728C6.71177 20.4501 0 12.8098 0 7.60537ZM3.7266 7.60537C3.7266 9.7153 5.41932 11.4318 7.5 11.4318C9.58064 11.4318 11.2734 9.71534 11.2734 7.60541C11.2734 5.49549 9.58064 3.77894 7.5 3.77894C5.41936 3.77894 3.7266 5.49544 3.7266 7.60537Z","fill":"white"}));
}

LocationIconInline.defaultProps = {"width":"15","height":"21","viewBox":"0 0 15 21","fill":"none"};

module.exports = LocationIconInline;

LocationIconInline.default = LocationIconInline;
